const requireEnv = (name: string, defaultValue?: string): string => {
  const value = process.env[name] ?? defaultValue;
  if (typeof value === 'undefined') {
    throw new Error(`No env value defined for key '${name}'`);
  }
  return value;
};

export default requireEnv;
